/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetSfxCollectionPageResponse,
  ProblemDetails
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1SfxCollectionsPageSlug = (
    slug: string | null,
 signal?: AbortSignal
) => {


      return apiClient<GetSfxCollectionPageResponse | null>(
      {url: `/api/v1/sfx-collections/page/${slug}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1SfxCollectionsPageSlugQueryKey = (slug: string | null,) => {
    return [
    `/api/v1/sfx-collections/page/${slug}`
    ] as const;
    }


export const getGetApiV1SfxCollectionsPageSlugQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError = ProblemDetails | null>(slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1SfxCollectionsPageSlugQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>> = ({ signal }) => getApiV1SfxCollectionsPageSlug(slug, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1SfxCollectionsPageSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>>
export type GetApiV1SfxCollectionsPageSlugQueryError = ProblemDetails | null


export function useGetApiV1SfxCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SfxCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1SfxCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1SfxCollectionsPageSlug<TData = Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1SfxCollectionsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1SfxCollectionsPageSlugQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






